import React from "react";
import { Phone, Instagram, Clock, MapPin, MessageCircle, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IONA, waLink } from "@/constants/site";

export default function Contact() {
  return (
    <section
      id="iletisim"
      data-testid="contact-section"
      className="iona-section bg-white"
    >
      <div className="iona-container">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-[#5E2A84] mb-4">
              — İletişim
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] leading-[1.1] tracking-tight mb-6">
              Size yardımcı olmak için <span className="italic text-[#5E2A84]">buradayız</span>
            </h2>
            <p className="text-[#4A4A4A] leading-relaxed mb-10 max-w-md">
              Sorularınız, randevu talepleriniz veya kampanyalar hakkında detaylı
              bilgi için bize ulaşın.
            </p>

            <ul className="space-y-6">
              <li className="flex items-start gap-4" data-testid="contact-address">
                <div className="w-11 h-11 rounded-full bg-[#F4F1F9] text-[#5E2A84] flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5" strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#5E2A84] mb-1">
                    Adres
                  </div>
                  <div className="text-[#1A1A1A]">İONA - Ümraniye Güzellik Merkezi</div>
                  <div className="text-[#4A4A4A] text-sm">{IONA.location}</div>
                </div>
              </li>
              <li className="flex items-start gap-4" data-testid="contact-phone">
                <div className="w-11 h-11 rounded-full bg-[#F4F1F9] text-[#5E2A84] flex items-center justify-center flex-shrink-0">
                  <Phone className="w-5 h-5" strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#5E2A84] mb-1">
                    Telefon & WhatsApp
                  </div>
                  <a href={`tel:${IONA.phoneIntl}`} className="text-[#1A1A1A] hover:text-[#5E2A84]">
                    {IONA.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-4" data-testid="contact-instagram">
                <div className="w-11 h-11 rounded-full bg-[#F4F1F9] text-[#5E2A84] flex items-center justify-center flex-shrink-0">
                  <Instagram className="w-5 h-5" strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#5E2A84] mb-1">
                    Instagram
                  </div>
                  <a
                    href={IONA.instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#1A1A1A] hover:text-[#5E2A84]"
                  >
                    @{IONA.instagram}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-4" data-testid="contact-hours">
                <div className="w-11 h-11 rounded-full bg-[#F4F1F9] text-[#5E2A84] flex items-center justify-center flex-shrink-0">
                  <Clock className="w-5 h-5" strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-[#5E2A84] mb-1">
                    Çalışma Saatleri
                  </div>
                  <div className="text-[#1A1A1A]">Pazartesi - Cumartesi</div>
                  <div className="text-[#4A4A4A] text-sm">10:00 - 19:00 · Pazar Kapalı</div>
                </div>
              </li>
            </ul>

            <div className="inline-flex flex-wrap gap-3 mt-10">
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contact-whatsapp-cta"
              >
                <Button className="h-13 px-7 py-3 rounded-full bg-[#5E2A84] hover:bg-[#4a2168] text-white iona-soft-shadow">
                  <MessageCircle className="w-4 h-4 mr-2" />
                  WhatsApp'tan Yaz
                </Button>
              </a>
              <a
                href={`tel:${IONA.phoneIntl}`}
                data-testid="contact-call-cta"
              >
                <Button
                  variant="outline"
                  className="h-13 px-7 py-3 rounded-full border-[#5E2A84]/25 text-[#5E2A84] hover:bg-[#F4F1F9] hover:text-[#5E2A84]"
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Hemen Ara
                </Button>
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative rounded-[2rem] overflow-hidden border border-[#F0F0F0] iona-soft-shadow h-[400px] lg:h-full min-h-[400px] bg-[#F8F9FA]">
              <iframe
                title="İONA Güzellik Salonu Konum"
                src={IONA.mapEmbed}
                className="w-full h-full border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
              <a
                href={IONA.mapDirections}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="map-directions-btn"
                className="absolute bottom-4 left-4 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white text-[#5E2A84] iona-soft-shadow hover:bg-[#F4F1F9] transition-colors text-sm font-medium"
              >
                <Navigation className="w-4 h-4" />
                Yol Tarifi Al
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
